import axios from "axios";

const Request = (state = [], action) => {
    switch (action.type) {
        case 'REQUEST_GET' :
            return axios.get('http://localhost:3000/Request')
                .then(function (res) {
                    return state = res.data;
                }.bind(this))
        case 'REQUEST_GET_SUCCESS' :

            state = action.payload;
            return state;
        default:
            return state;
    }
};
export default Request;
